import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import CTA from "./components/CTA";
import Features from "./components/Features";
import BentoGrid from "./components/BentoGrid";
import Contact from "./components/Contact";
import QuickActions from "./components/QuickActions";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  return (
    <div className="App">
      <Header />

      <main>
        <Hero />

        <About />
        <CTA />
        <Features />
        <BentoGrid />
        <Contact />
        <QuickActions />

        <section
          style={{
            background: "#0d0d0d",
            padding: "40px 0",
            textAlign: "center",
            fontFamily: "var(--font-body)",
            fontSize: "13px",
            color: "rgba(255,255,255,0.45)",
            letterSpacing: "0.06em",
          }}
        >
          © {new Date().getFullYear()} Sunleaf Villa. All Rights Reserved.
        </section>
      </main>
    </div>
  );
}

export default App;
